import { ExperimentsAction, ExperimentAnalyticsMetricsState } from 'modules/experiments/types';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

export const initialAnalyticsMetricsState: ExperimentAnalyticsMetricsState = [];

export const experimentAnalyticsMetricsReducer = (
  state = initialAnalyticsMetricsState,
  action?: ExperimentsAction,
) => {
  switch (action?.type) {
    case ActionTypes.SET_ANALYTICS_METRICS: {
      const analyticsMetrics = action?.payload;
      return analyticsMetrics || state;
    }

    default:
      return state;
  }
};
